import React, { Component } from "react";
import { FormControl, MenuItem, OutlinedInput, Select } from "@material-ui/core";

import FontControl from "./Font/FontControl";
import ThemeSection from "./ThemeSection";
import { ThemeSpinner } from "./Common/ThemeCommon";
import { fontManager } from "js/core/services/fonts";
import { Gap20 } from "js/react/components/Gap";
import CheckBox from "js/react/components/CheckBox";
import { BetaBadge } from "js/react/components/BetaBadge";
import { FlexBox } from "js/react/components/LayoutGrid";
import { trackActivity } from "js/core/utilities/utilities";

export const getCurrentFontStyle = (theme, fonts, textStyle) => {
    const fontId = (
        theme[`originalFont${textStyle}FontId`] ||
        theme[`font${textStyle}FontId`]
    );
    const fontWeight = theme[`font${textStyle}Weight`];

    const font = fonts.find(font => font.id === fontId);
    // Fonts haven't loaded yet
    if (!font) {
        return null;
    }

    let style = fontManager.getFontStyle(font.styles, fontWeight, false);
    if (theme[`originalFont${textStyle}FontId`]) {
        style.isInvalid = true;
    }

    return {
        ...style,
        fontId
    };
};

export default class ThemeTypography extends Component {
    constructor(props) {
        super(props);
        this.updateValue = this.updateValue.bind(this);

        this.state = {
            isRTL: props.theme.isRTL
        };
    }

    componentDidMount = async () => {
        let {
            fonts,
            fetchFonts,
        } = this.props;

        if (!fonts?.length) {
            await fetchFonts();
        }
    };

    updateValue = attribute => event => {
        this.props.update({ [attribute]: event.target.value });
    };

    handleChangeRTL = checked => {
        this.setState({
            isRTL: checked
        });
        trackActivity("Theme", "ChangeRTL", null, null, {
            isRTL: checked
        }, { audit: false });
        this.props.update({ isRTL: checked });
    }

    render() {
        const {
            theme,
            update,
            fonts,
            orgId,
            isSharedTheme,
            fetchFonts,
        } = this.props;

        if (!fonts?.length) {
            return <ThemeSpinner />;
        }

        let headerFontStyle = getCurrentFontStyle(theme, fonts, "Header");
        let titleFontStyle = getCurrentFontStyle(theme, fonts, "Title");
        let bodyFontStyle = getCurrentFontStyle(theme, fonts, "Body");

        return (
            <ThemeSection title="Typography">
                <FontControl
                    label="Header"
                    style="Header"
                    update={update}
                    theme={theme}
                    fonts={fonts}
                    currentFontStyle={headerFontStyle}
                    refreshFonts={fetchFonts}
                    orgId={orgId}
                    isSharedTheme={isSharedTheme}
                />
                <FontControl
                    label="Title"
                    style="Title"
                    update={update}
                    theme={theme}
                    fonts={fonts}
                    currentFontStyle={titleFontStyle}
                    refreshFonts={fetchFonts}
                    orgId={orgId}
                    isSharedTheme={isSharedTheme}
                />
                <FontControl
                    label="Body"
                    style="Body"
                    update={update}
                    theme={theme}
                    fonts={fonts}
                    currentFontStyle={bodyFontStyle}
                    refreshFonts={fetchFonts}
                    orgId={orgId}
                    isSharedTheme={isSharedTheme}
                />

                <div>
                    <h4>Font Scale</h4>
                    <FormControl style={{ width: 90 }}>
                        <Select
                            value={theme.fontScale}
                            onChange={this.updateValue("fontScale")}
                            input={
                                <OutlinedInput
                                    name="fontScale"
                                    labelWidth={0}
                                />
                            }
                        >
                            <MenuItem value={1}>100%</MenuItem>
                            <MenuItem value={1.25}>125%</MenuItem>
                            <MenuItem value={1.5}>150%</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                <div>
                    <h4 style={{ paddingRight: 14 }}>CJK Font</h4>
                    <FormControl style={{ width: 160 }}>
                        <Select
                            value={theme.cjkFont}
                            onChange={this.updateValue("cjkFont")}
                            input={
                                <OutlinedInput
                                    name="cjkFont"
                                    labelWidth={0}
                                />
                            }
                        >
                            <MenuItem value="jp">Japanese</MenuItem>
                            <MenuItem value="kr">Korean</MenuItem>
                            <MenuItem value="sc">Simplified Chinese</MenuItem>
                            <MenuItem value="tc">Traditional Chinese</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                <Gap20 />

                <FlexBox left>
                    <CheckBox
                        checked={this.state.isRTL ?? false}
                        onChange={this.handleChangeRTL}
                        label="Use RTL Text"
                    />
                    <BetaBadge />
                </FlexBox>
            </ThemeSection>
        );
    }
}
